var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "eu-flex" }, [
      _c(
        "div",
        { staticClass: "eu-flex-item eu-basis_12 eu-basis_8_md" },
        [
          _c("Items", { on: { formIsValid: _vm.formValidation } }),
          _c("Shipping"),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "eu-flex-item eu-basis_12 eu-basis_4_md" },
        [_c("Summary")],
        1
      ),
    ]),
    _c("div", { staticClass: "el-section" }, [
      _c("div", { staticClass: "eu-display_flex" }, [
        _c(
          "button",
          {
            staticClass: "emd-btn _color_secondary _type_text _block_mobile",
            on: { click: _vm.goBack },
          },
          [
            _c("i", { staticClass: "uil uil-angle-left" }),
            _vm._v(" " + _vm._s(_vm.$t("back")) + " "),
          ]
        ),
        _c(
          "button",
          {
            staticClass: "emd-btn _color_secondary _block_mobile eu-ml_auto",
            on: { click: _vm.next },
          },
          [
            _vm._v(" " + _vm._s(_vm.$t("next")) + " "),
            _c("i", { staticClass: "uil uil-angle-right" }),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }